import React, { useState } from "react";
import PropTypes from "prop-types";
import { ArrowDownIcon } from "../../../../../components/Icons/ArrowDownIcon";

function Gender(props) {
  const { title, options, value, name, onChange, isLastest, t } = props;
  const [show, $show] = useState(true);
  const onChangeRadio = (e, val) => {
    const data = [];
    if (val != "") {
      data.push(val);
    }
    onChange(data);
  };

  return (
    <div
      className={
        "pt-[32px] pb-7 px-0" +
        (isLastest ? "" : " border-b border-solid border-black/[.15]")
      }
    >
      <div
        className="flex items-center justify-between text-lg font-bold text-black cursor-pointer"
        onClick={() => $show(!show)}
      >
        <span>{title}</span>
        {show && <ArrowDownIcon className="rotate-180 w-[12px] h-[12px]" />}
        {!show && <ArrowDownIcon className="w-[12px] h-[12px]" />}
      </div>
      <div
        className={
          "flex items-center justify-start flex-wrap gap-[14px] mt-[30px]" +
          (show ? "" : " hidden")
        }
      >
        {options.map((item, index) => {
          return (
            <label
              key={index}
              className={
                "h-[50px] min-w-[50px] text-base text-black text-center cursor-pointer rounded-[15px] p-[1px]" +
                (value?.includes(item.value) ||
                (value?.length == 0 && item.value == "")
                  ? " bg-aia-red"
                  : "")
              }
            >
              <span className="block text-base text-black bg-white w-full h-full py-3 px-2.5 rounded-[13px]">
                {t(item.title)}
              </span>
              <input
                type="radio"
                name={name}
                value={item.value}
                onChange={($event) => onChangeRadio($event, item.value)}
                className="hidden"
              />
            </label>
          );
        })}
      </div>
    </div>
  );
}

Gender.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  name: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
  isLastest: PropTypes.bool,
};

export default Gender;
